/* Polna · strona główna v3: efekty przewijania.
   A. hero full-bleed (CSS scroll-timeline, fallback JS), B. galeria pozioma w przypiętej sekcji,
   C/E. powiększenie 1.12 -> 1.0 zdjęć pełnoekranowych, F. wejścia: clip-path obrazów i słowa nagłówków.
   Tylko transform, opacity, clip-path. prefers-reduced-motion: bez ruchu. */

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const root = document.documentElement;
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const mobile = matchMedia('(max-width: 760px)');
const clamp01 = (x) => Math.max(0, Math.min(1, x));

root.classList.add('v3');
const sda = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: scroll()');
if (sda && !reduced) root.classList.add('v3-sda');

/* ---------- F. nagłówki słowami spod maski ---------- */
const splitWords = (el) => {
  if (el.dataset.wordsReady) return;
  const text = el.textContent;
  const sr = document.createElement('span');
  sr.className = 'sr'; sr.textContent = text;
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  const nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
  let i = 0;
  for (const tn of nodes) {
    const frag = document.createDocumentFragment();
    for (const part of tn.nodeValue.split(/(\s+)/)) {
      if (!part) continue;
      if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); continue; }
      const w = document.createElement('span'); w.className = 'v3-w'; w.setAttribute('aria-hidden', 'true');
      const wi = document.createElement('span'); wi.className = 'v3-wi'; wi.textContent = part;
      wi.style.setProperty('--wd', `${i++ * 70}ms`);
      w.appendChild(wi); frag.appendChild(w);
    }
    tn.parentNode.replaceChild(frag, tn);
  }
  el.prepend(sr);
  el.dataset.wordsReady = '1';
};

const heads = $$('section h2.h2, [data-words]').filter((el, i, a) => a.indexOf(el) === i && !el.closest('.intro, .coll'));
if (!reduced) heads.forEach(splitWords);

const onceIO = new IntersectionObserver((es) => es.forEach((e) => {
  if (!e.isIntersecting) return;
  const el = e.target;
  // element w pełni przycięty clip-path nie jest widoczny dla IO, więc obserwujemy rodzica
  if (el._clip) el._clip.classList.add('is-open'); else el.classList.add('is-words');
  onceIO.unobserve(el);
}), { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
if (!reduced) {
  heads.forEach((el) => onceIO.observe(el));
  $$('[data-clip]').forEach((el) => { const p = el.parentElement; p._clip = el; onceIO.observe(p); });
} else {
  $$('[data-clip]').forEach((el) => el.classList.add('is-open'));
}

/* ---------- pętla przewijania (jedna, tylko rAF przy scrollu) ---------- */
const frame = $('[data-bleed]');
const day = $('[data-day]');
const track = $('[data-day-track]');
const viewport = $('[data-day-viewport]');
const bar = $('[data-day-bar]');
const zooms = $$('[data-zoom] img');
let pad = 0, vh = innerHeight, dayMax = 0, dayTop = 0, dayH = 0;

const measure = () => {
  vh = innerHeight;
  pad = frame ? parseFloat(getComputedStyle(frame.parentElement).paddingLeft) || 0 : 0;
  if (day && track) {
    const r = day.getBoundingClientRect();
    dayTop = r.top + scrollY; dayH = day.offsetHeight;
    dayMax = Math.max(0, track.scrollWidth - viewport.clientWidth);
  }
};

const horizontal = () => !reduced && !mobile.matches;

const update = () => {
  ticking = false;
  const y = scrollY;
  // A. fallback JS dla hero (gdy brak scroll-timeline)
  if (frame && !sda && !reduced) {
    const p = clamp01(y / (vh * 0.55));
    const v = (pad * (1 - p)).toFixed(2) + 'px';
    frame.style.clipPath = `inset(0 ${v} ${v} ${v})`;
  }
  // B. galeria pozioma
  if (day && track) {
    if (horizontal()) {
      const p = clamp01((y - dayTop) / Math.max(1, dayH - vh));
      track.style.transform = `translate3d(${(-p * dayMax).toFixed(1)}px,0,0)`;
      if (bar) bar.style.transform = `scaleX(${p.toFixed(4)})`;
    } else if (bar) {
      const p = dayMax ? viewport.scrollLeft / Math.max(1, viewport.scrollWidth - viewport.clientWidth) : 0;
      bar.style.transform = `scaleX(${clamp01(p).toFixed(4)})`;
    }
  }
  // C/E. powiększenie 1.12 -> 1.0, gdy zdjęcie przechodzi przez ekran
  if (!reduced) for (const img of zooms) {
    const r = img.parentElement.getBoundingClientRect();
    if (r.bottom < 0 || r.top > vh) continue;
    const p = clamp01((vh - r.top) / (vh + r.height * 0.5));
    img.style.setProperty('--z', (1.12 - 0.12 * p).toFixed(4));
  }
};

let ticking = false;
const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
addEventListener('scroll', req, { passive: true });
addEventListener('resize', () => { measure(); req(); });
if (viewport) viewport.addEventListener('scroll', req, { passive: true });
mobile.addEventListener && mobile.addEventListener('change', () => { if (track) track.style.transform = ''; measure(); req(); });
// obrazy galerii wczytują się leniwie: pomiar po każdym wczytaniu
$$('img', track || document.createElement('div')).forEach((img) => img.addEventListener('load', () => { measure(); req(); }, { once: true }));
addEventListener('load', () => { measure(); req(); });
measure(); update();

// galeria: obrazy leniwe są poza ekranem w poziomie; wczytujemy je, gdy sekcja się zbliża
if (day) {
  const pre = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    $$('img[loading="lazy"]', day).forEach((i) => { i.loading = 'eager'; });
    pre.disconnect();
  }), { rootMargin: '600px 0px' });
  pre.observe(day);
}
